var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDfk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DFK_Chain",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 216 216",
    style: {
      enableBackground: "new 0 0 216 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFC629;}\n\t.st1{fill:#80BC00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.74,216H63.26L0,152.74V63.26L63.26,0h89.47L216,63.26v89.47L152.74,216z M68.86,202.5h78.29l55.36-55.36 V68.86L147.14,13.5H68.86L13.5,68.86v78.29L68.86,202.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.46,95.76v38.53l-32.01,32.01l-7.58-18.31l21.28-21.28v-5.69h-13.4h-0.1v0.1l-18.54,18.54H94.89 l-18.54-18.54V94.89l18.54-18.54h26.22l18.54,18.54v0.17h0.17h13.33V89.3l-21.28-21.28l7.58-18.31l10.05,10.05 c-0.47,1.45-0.74,3-0.74,4.62c0,8.23,6.67,14.9,14.9,14.9s14.9-6.67,14.9-14.9s-6.67-14.9-14.9-14.9c-1.61,0-3.16,0.26-4.62,0.74 l-19.17-19.17H76.12L31.04,76.12v63.75l45.08,45.08h63.75l45.08-45.08V95.76H171.46z M96.6,153.15h22.79l7.58,18.31H89.02 L96.6,153.15z M84.13,147.98l-7.58,18.31l-26.84-26.84l18.31-7.58L84.13,147.98z M62.85,96.6v22.79l-18.31,7.58V89.02L62.85,96.6z  M68.01,84.13l-18.31-7.58l26.84-26.84l7.58,18.31L68.01,84.13z M89.02,44.54h37.96l-7.58,18.31H96.6L89.02,44.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.11,212.55h-1.18v-0.43h2.87v0.43h-1.19V216h-0.51V212.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.5,214.3c-0.03-0.54-0.06-1.19-0.06-1.68h-0.02c-0.13,0.45-0.29,0.94-0.49,1.47l-0.69,1.88h-0.38 l-0.63-1.85c-0.18-0.55-0.34-1.05-0.45-1.51h-0.01c-0.01,0.48-0.04,1.13-0.07,1.72l-0.1,1.66h-0.48l0.27-3.88h0.64l0.66,1.88 c0.16,0.48,0.29,0.9,0.39,1.31h0.02c0.1-0.39,0.24-0.82,0.41-1.31l0.69-1.88h0.64l0.24,3.88h-0.49L165.5,214.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfk);
export default __webpack_public_path__ + "static/media/dfk.b835964b71a810c11cdaa4b88e47beb8.svg";
export { ForwardRef as ReactComponent };